import { Listing } from "./Listing";


export class OrderedListing {
	public static readonly $type: string = "OrderedListing";
	public readonly $type: string = OrderedListing.$type;

	public id?: number;
	public order: number = 0;
	public item!: Listing;

	public static sort = (a: OrderedListing, b: OrderedListing): number => {

		// Check For Identical Orders
		if (a.order === b.order) {

			// Sort Alphabetically
			return a.item.name.localeCompare(b.item.name);
		}

		// Check Numeric Order
		return a.order - b.order;
	}
}
